import { Link } from "react-router-dom";
import { Button } from "../Button";
import { Menu, X } from "lucide-react";
import { MouseEvent, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  logout,
  selectCurrentUser,
  selectRefreshToken,
  selectToken,
} from "../../features/authSlice";
import supabase from "../../helper/supabaseClient";
import { config } from "../../utils/config";
import { redirectToDashboard } from "../../utils/dashboardRedirect";

const Navbar = () => {
  const dispatch = useDispatch();
  const token = useSelector(selectToken);
  const refreshToken = useSelector(selectRefreshToken);
  const currentUser = useSelector(selectCurrentUser);
  const [isOpen, setIsOpen] = useState(false);
  const [hasValidSession, setHasValidSession] = useState(false);
  const toggleSidebar = () => setIsOpen(!isOpen);
  const nav = [

    {
      name: "Home",
      link: '/'
    },
    {
      name: "Pricing",
      link: '/pricing'
    },
    {
      name: "JBA",
      link: '/jba'
    },
    {
      name: "Jellopages",
      link: '/jellopages'
    },
  ]

  const path = window.location.pathname

  const handleDashboardClick = async (
    event: MouseEvent<HTMLAnchorElement>
  ) => {
    event.preventDefault();
    await redirectToDashboard({
      fallbackAccessToken: token,
      fallbackRefreshToken: refreshToken,
    });
  };

  useEffect(() => {
    let cancelled = false;

    const validateSession = async () => {
      if (!token || !currentUser) {
        setHasValidSession(false);
        return;
      }

      const { data: sessionData } = await supabase.auth.getSession();
      if (cancelled) return;

      const candidateToken = sessionData.session?.access_token || token;
      const { data: userData, error } = await supabase.auth.getUser(
        candidateToken
      );
      if (cancelled) return;

      if (error || !userData.user) {
        dispatch(logout());
        setHasValidSession(false);
        return;
      }

      setHasValidSession(true);
    };

    validateSession();

    return () => {
      cancelled = true;
    };
  }, [currentUser, dispatch, token]);

  return (
    <div className="top-0 sticky z-50">
      <div className="px-4 md:px-8  py-4 flex items-center justify-between w-full bg-white">
        <Link to="/">
          <img
            src="/assets/JellositeLogoandWordmark05.png"
            alt=""
            className="w-38 block h-10"
          />
        </Link>
        <ul className="md:flex items-center text-lg  justify-center gap-8 lg:gap-16 hidden">
          {
            nav.map((item, index) => {
              return (
                <Link key={index} to={item.link}>
                  <li className={`text-[#1A1A1A] ${item.link === path && "font-bold"} hover:text-gray-500`}>{item.name}</li>
                </Link>
              );
            })
          }
          {/* <Link to="/courses" className=" flex items-end justify-center gap-2">
            <li>JBA</li>
            <BookOpenTextIcon />
          </Link> */}
        </ul>
        {hasValidSession ? (
          <a
            href={config.DASHBOARD_URL}
            onClick={handleDashboardClick}
            className="cursor-pointer hidden md:block"
          >
            <Button
              text={"Go to dashboard"}
              className="bg-[#945bf5] rounded-[40px] transition-all duration-300 ease-in-out hover:bg-white hover:text-[#945bf5] hover:shadow-[0_0_0_2px_#945bf5]"
            />
          </a>
        ) : (
          <Link to="/signup" className=" cursor-pointer hidden md:block">
            <Button
              text={"Try for free"}
              className="bg-[#945bf5] rounded-[40px] transition-all duration-300 ease-in-out hover:bg-white hover:text-[#945bf5] hover:shadow-[0_0_0_2px_#945bf5]"
            />
          </Link>
        )}

        <button
          className="block md:hidden p-2 cursor-pointer"
          onClick={toggleSidebar}
          aria-label="Toggle Menu"
        >
          {isOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      {/* BACKDROP */}
      <div
        className={`fixed inset-0 bg-black/50 z-40 transition-opacity duration-300 ${isOpen ? "opacity-100 visible" : "opacity-0 invisible"
          }`}
        onClick={toggleSidebar}
      />

      {/* SIDEBAR */}
      <aside
        className={`fixed inset-y-0 left-0 w-full bg-white shadow-lg z-50 transform transition-transform duration-500 ease-in-out
          ${isOpen ? "translate-x-0" : "-translate-x-full"}`}
      >
        <div className="flex items-center justify-between w-full p-4">
          <img
            src="/assets/JellositeLogoandWordmark05.png"
            alt=""
            className="w-38 h-10"
          />
          <X size={24} onClick={toggleSidebar} />
        </div>
        <nav className="flex flex-col p-6 gap-2">
          {
            nav.map((item, index) => {

              return (
                <Link
                  key={index}
                  to={item.link}
                  onClick={toggleSidebar}
                  className={`hover:text-gray-500 ${item.link === path && "font-bold"}`}
                >
                  {item.name}
                </Link>
              );
            })
          }
          {/* Home
          </Link>
          <Link to="/about" onClick={toggleSidebar}>
            About
          </Link>
          <Link to="/pricing" onClick={toggleSidebar}>
            Pricing
          </Link>
          <Link to="/webinar" target="_blank" onClick={toggleSidebar}>
            Webinar
          </Link>
          <Link
            to="/courses"
            className=" flex items-center justify-start gap-2"
            onClick={toggleSidebar}
          >
            JBA
            <BookOpenTextIcon />
          </Link> */}
          {hasValidSession ? (
            <a
              href={config.DASHBOARD_URL}
              onClick={async (event) => {
                toggleSidebar();
                await handleDashboardClick(event);
              }}
              className="mt-4"
            >
              <Button text="Go to dashboard" className="w-full" />
            </a>
          ) : (
            <Link to="/signup" onClick={toggleSidebar} className="mt-4">
              <Button text="Create your store" className="w-full" />
            </Link>
          )}
        </nav>
      </aside>
    </div>
  );
};

export default Navbar;
